var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 77,
    viewBox: "0 0 115 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.13 69.6519C40.3884 71.9956 34.7255 72.254 31.4844 70.2214V72.8936C34.7255 74.9263 40.3884 74.6722 44.13 72.3241V69.6519Z",
    fill: "#3F92D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4805 70.2212L2.74234 52.2117C1.3458 51.3355 0.62734 50.1746 0.56276 48.9524C0.554688 49.4781 0.554688 51.3969 0.554688 51.4976C0.574869 52.7681 1.29332 53.9772 2.74234 54.8884L31.4805 72.8978V70.2212Z",
    fill: "#3F92D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.4805 74.8034L2.74235 56.7939C-0.498773 54.7613 -0.0911107 51.2128 3.65051 48.8691L71.2297 6.52431C74.9713 4.18059 80.6342 3.92212 83.8753 5.95481L112.613 23.9643C115.855 25.997 115.447 29.5454 111.705 31.8891L44.1302 74.2339C40.3845 76.5776 34.7217 76.8361 31.4805 74.8034Z",
    fill: "#92B4D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72322 45.4258L73.0481 3.23875C75.7928 1.5171 79.9501 1.32872 82.3275 2.82258L110.303 20.3545C112.68 21.844 112.382 24.4506 109.637 26.1678L42.316 68.3549C39.5673 70.0766 35.414 70.2649 33.0366 68.7711L5.06128 51.2391C2.67988 49.7497 2.97856 47.1475 5.72322 45.4258Z",
    fill: "#022652"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78708 51.0551C5.05751 50.8097 5.3683 50.5776 5.71945 50.3541L73.0403 8.16707C75.785 6.44542 79.9423 6.25705 82.3197 7.7509L110.295 25.2828C110.392 25.3442 110.473 25.4055 110.561 25.4712C112.406 23.8021 112.37 21.6555 110.295 20.3544L82.3237 2.8225C79.9464 1.33303 75.789 1.51703 73.0443 3.23868L5.71945 45.4257C3.08377 47.0773 2.71244 49.5393 4.78708 51.0551Z",
    fill: "#001A46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0715 47.0862L109.429 27.1842C111.657 25.7868 111.645 23.5175 109.405 22.1113L82.0755 4.98675C79.8353 3.58051 76.2108 3.57613 73.9827 4.96923L42.625 24.8712L78.0715 47.0862Z",
    fill: "#92B4D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6826 27.4473C42.4405 27.5568 42.2104 27.6795 41.9844 27.8066V25.5986L42.6826 27.4473Z",
    fill: "#2672AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3468 40.4275L44.5234 41.2642L45.3468 40.4275Z",
    fill: "url(#paint0_linear_2164_1087)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4942 35.3238L54.5356 34.8726C54.2813 35.0872 54.0109 35.2975 53.696 35.4946C53.3853 35.6918 53.0502 35.8626 52.7031 36.0203L53.4216 37.8734V38.3115C53.5144 38.2589 53.6073 38.2107 53.696 38.1538C54.0068 37.9566 54.2813 37.7464 54.5356 37.5317V34.8726L57.4942 35.3238Z",
    fill: "#2672AB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49 36.9797L49.7709 37.7639L49 36.9797Z",
    fill: "url(#paint1_linear_2164_1087)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5703 37.6938L57.4997 37.9874L55.5703 37.6938Z",
    fill: "url(#paint2_linear_2164_1087)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49 39.6389L49.7709 40.4275L49 39.6389Z",
    fill: "url(#paint3_linear_2164_1087)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.589 38.605L49.7656 37.7639L50.589 38.605Z",
    fill: "url(#paint4_linear_2164_1087)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5943 38.605L49.7709 37.7639L49 36.9797V39.6389L49.7709 40.4274L50.5943 41.2642V38.605Z",
    fill: "url(#paint5_linear_2164_1087)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5943 38.605L49.7709 37.7639L49 36.9797V39.6389L49.7709 40.4274L50.5943 41.2642V38.605Z",
    fill: "#2672AB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4191 37.8777C52.5231 38.2019 51.5746 38.4472 50.5938 38.6049V41.264V41.2728L50.7068 41.2421C51.6109 41.0888 52.4868 40.8654 53.3182 40.5719L53.4191 40.5456V38.3158V37.8777Z",
    fill: "url(#paint6_linear_2164_1087)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4191 37.8777C52.5231 38.2019 51.5746 38.4472 50.5938 38.6049V41.264V41.2728L50.7068 41.2421C51.6109 41.0888 52.4868 40.8654 53.3182 40.5719L53.4191 40.5456V38.3158V37.8777Z",
    fill: "#3F92D1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5391 37.5359L55.5683 37.6936L54.5391 37.5359Z",
    fill: "url(#paint7_linear_2164_1087)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4976 35.3238L54.5391 34.877V37.5361L55.5683 37.6938L57.4976 37.9873V35.3238Z",
    fill: "url(#paint8_linear_2164_1087)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4976 35.3238L54.5391 34.877V37.5361L55.5683 37.6938L57.4976 37.9873V35.3238Z",
    fill: "#3F92D1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6584 33.554C58.4041 34.1673 58.0207 34.7631 57.5 35.3238V37.9829C58.0207 37.4222 58.4041 36.8264 58.6584 36.2131V33.554Z",
    fill: "url(#paint9_linear_2164_1087)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6584 33.554C58.4041 34.1673 58.0207 34.7631 57.5 35.3238V37.9829C58.0207 37.4222 58.4041 36.8264 58.6584 36.2131V33.554Z",
    fill: "#2672AB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0547 30.9254L56.0749 31.0261C56.1879 31.5343 56.1879 32.0469 56.0628 32.555L57.4028 33.072L58.6379 32.5988V29.9397L56.0547 30.9254Z",
    fill: "#2672AB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6641 27.4473C52.9062 27.5568 53.1363 27.6795 53.3623 27.8066V25.5986L52.6641 27.4473Z",
    fill: "#2672AB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6324 33.5102L56.0613 32.5245C56.1219 32.2573 56.1541 31.99 56.1501 31.7228C56.1541 31.4556 56.1219 31.184 56.0613 30.9167L58.6324 29.9311C58.6284 29.9223 58.6203 29.9092 58.6163 29.9004L58.6486 29.8873C58.3943 29.2739 58.0108 28.6782 57.4902 28.1174L54.5316 28.5686C54.2773 28.354 54.0069 28.1437 53.692 27.9466C53.3812 27.7494 53.0462 27.5786 52.6991 27.4209L53.4176 25.5678C52.5215 25.2436 51.573 24.9983 50.5922 24.8406L50.572 24.8625C50.5558 24.8581 50.5397 24.8581 50.5236 24.8537L48.9534 26.4659C48.5296 26.4264 48.1018 26.4089 47.674 26.4089C47.2461 26.4089 46.8183 26.4264 46.3945 26.4659L44.8243 24.8537C44.8082 24.8581 44.7921 24.8581 44.7759 24.8625L44.7557 24.8406C43.7749 24.9983 42.8264 25.2392 41.9303 25.5678L42.6488 27.4209C42.3017 27.5786 41.9667 27.7494 41.6559 27.9466C41.3451 28.1437 41.0706 28.354 40.8163 28.5686L37.8578 28.1174C37.3371 28.6782 36.9496 29.2739 36.6993 29.8873L36.7316 29.9004C36.7276 29.9092 36.7195 29.9223 36.7155 29.9311L39.2826 30.9167C39.222 31.184 39.1897 31.4512 39.1938 31.7228C39.1897 31.99 39.222 32.2573 39.2826 32.5245L36.7115 33.5102C36.7155 33.5189 36.7236 33.5321 36.7276 33.5408L36.6953 33.554C36.9496 34.1673 37.333 34.7631 37.8537 35.3238L40.8123 34.8726C41.0666 35.0873 41.337 35.2975 41.6518 35.4947C41.9626 35.6918 42.2976 35.8627 42.6448 36.0204L41.9263 37.8734C42.8224 38.1976 43.7709 38.4429 44.7517 38.6007L44.7719 38.5787C44.788 38.5831 44.8042 38.5831 44.8203 38.5875L46.3904 36.9798C46.8142 37.0192 47.2421 37.0367 47.6699 37.0367C48.0978 37.0367 48.5256 37.0192 48.9494 36.9798L50.5195 38.5875C50.5357 38.5831 50.5518 38.5831 50.568 38.5787L50.5881 38.6007C51.5689 38.4429 52.5175 38.202 53.4135 37.8734L52.6951 36.0204C53.0422 35.8627 53.3772 35.6918 53.688 35.4947C53.9988 35.2975 54.2732 35.0873 54.5275 34.8726L57.4861 35.3238C58.0068 34.7631 58.3902 34.1673 58.6445 33.554L58.6122 33.5408C58.6203 33.5321 58.6284 33.5233 58.6324 33.5102ZM50.6043 33.5627C49.793 34.0709 48.7315 34.3294 47.6699 34.3338C46.6084 34.3294 45.5468 34.0753 44.7356 33.5627C43.9243 33.0546 43.5166 32.3887 43.5085 31.7272C43.5166 31.0613 43.9243 30.3954 44.7356 29.8873C45.5468 29.3791 46.6084 29.1206 47.6699 29.1162C48.7315 29.1206 49.793 29.3747 50.6043 29.8873C51.4156 30.3954 51.8273 31.0613 51.8313 31.7272C51.8273 32.3887 51.4196 33.0546 50.6043 33.5627Z",
    fill: "#72B5E8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8594 35.3238L40.818 34.8726C41.0722 35.0872 41.3427 35.2975 41.6575 35.4946C41.9683 35.6918 42.3033 35.8626 42.6504 36.0203L41.932 37.8734V38.3115C41.8391 38.2589 41.7463 38.2107 41.6575 38.1538C41.3467 37.9566 41.0722 37.7464 40.818 37.5317V34.8726L37.8594 35.3238Z",
    fill: "#3F92D1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9469 36.9841V36.9753C48.5231 37.0148 48.0993 37.0367 47.6755 37.0411C47.2516 37.0411 46.8238 37.0191 46.404 36.9753V36.9841C46.3879 36.9841 46.3677 36.9841 46.3516 36.9797V39.6389C46.7915 39.6827 47.2355 39.7002 47.6755 39.7002C48.1194 39.7002 48.5634 39.6827 48.9994 39.6389V36.9797C48.9832 36.9797 48.963 36.9797 48.9469 36.9841Z",
    fill: "#3F92D1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3412 36.9797L45.5703 37.7639L46.3412 36.9797Z",
    fill: "url(#paint10_linear_2164_1087)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7887 37.6938L37.8594 37.9874L39.7887 37.6938Z",
    fill: "url(#paint11_linear_2164_1087)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3412 39.6389L45.5703 40.4275L46.3412 39.6389Z",
    fill: "url(#paint12_linear_2164_1087)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7578 38.605L45.5812 37.7639L44.7578 38.605Z",
    fill: "url(#paint13_linear_2164_1087)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7578 38.605L45.5812 37.7639L46.3521 36.9797V39.6389L45.5812 40.4274L44.7578 41.2642V38.605Z",
    fill: "url(#paint14_linear_2164_1087)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7578 38.605L45.5812 37.7639L46.3521 36.9797V39.6389L45.5812 40.4274L44.7578 41.2642V38.605Z",
    fill: "#2672AB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9297 37.8777C42.8257 38.2019 43.7743 38.4472 44.7551 38.6049V41.264V41.2728L44.6421 41.2421C43.7379 41.0888 42.8621 40.8654 42.0306 40.5719L41.9297 40.5456V38.3158V37.8777Z",
    fill: "url(#paint15_linear_2164_1087)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9297 37.8777C42.8257 38.2019 43.7743 38.4472 44.7551 38.6049V41.264V41.2728L44.6421 41.2421C43.7379 41.0888 42.8621 40.8654 42.0306 40.5719L41.9297 40.5456V38.3158V37.8777Z",
    fill: "#3F92D1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8143 37.5359L39.7891 37.6936L40.8143 37.5359Z",
    fill: "url(#paint16_linear_2164_1087)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8594 35.3238L40.8139 34.877V37.5361L39.7887 37.6938L37.8594 37.9873V35.3238Z",
    fill: "url(#paint17_linear_2164_1087)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8594 35.3238L40.8139 34.877V37.5361L39.7887 37.6938L37.8594 37.9873V35.3238Z",
    fill: "#2672AB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6953 33.554C36.9496 34.1673 37.333 34.7631 37.8537 35.3238V37.9829C37.333 37.4222 36.9496 36.8264 36.6953 36.2131V33.554Z",
    fill: "url(#paint18_linear_2164_1087)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6953 33.554C36.9496 34.1673 37.333 34.7631 37.8537 35.3238V37.9829C37.333 37.4222 36.9496 36.8264 36.6953 36.2131V33.554Z",
    fill: "#3F92D1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.302 30.9254L39.2818 31.0261C39.1688 31.5343 39.1688 32.0469 39.2939 32.555L37.9538 33.072L36.7188 32.5988V29.9397L39.302 30.9254Z",
    fill: "#2672AB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6275 29.8741C49.8162 29.366 48.7466 29.1119 47.677 29.1163C46.6074 29.1119 45.5378 29.366 44.7265 29.8741C43.9192 30.3823 43.5196 31.0438 43.5237 31.7097C43.5156 32.1784 43.7093 32.6516 44.1049 33.0677C44.2825 32.8838 44.4924 32.7041 44.7467 32.5464C45.558 32.0383 46.6195 31.7798 47.681 31.7754C48.7426 31.7798 49.8041 32.0339 50.6154 32.5464C50.8697 32.7041 51.0796 32.8838 51.2572 33.0677C51.6527 32.6516 51.8465 32.1784 51.8384 31.7097C51.8343 31.0482 51.4348 30.3823 50.6275 29.8741Z",
    fill: "#2672AB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M49.098 26.3171L50.4744 24.9065C50.4744 24.9065 50.4704 24.9065 50.4663 24.9065L49.0859 26.3171C49.09 26.3127 49.094 26.3127 49.098 26.3171Z",
    fill: "#A8CFF0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2233 30.8818L58.5724 29.9838C58.5684 29.975 58.5603 29.9619 58.5563 29.9531L58.5886 29.94C58.5805 29.9181 58.5643 29.8918 58.5563 29.8699L56.2031 30.7723C56.2112 30.8074 56.2152 30.8424 56.2233 30.8818Z",
    fill: "#A8CFF0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2093 33.0679C51.7138 32.6211 51.9762 32.0998 51.9802 31.5741C51.9722 30.9082 51.5645 30.2423 50.7532 29.7342C49.9419 29.226 48.8804 28.9675 47.8188 28.9631C46.7573 28.9675 45.6958 29.2216 44.8845 29.7342C44.6221 29.9006 44.4042 30.0802 44.2266 30.273C44.3638 30.1547 44.5131 30.0364 44.6827 29.9313C45.494 29.4231 46.5555 29.1647 47.617 29.1603C48.6786 29.1647 49.7401 29.4187 50.5514 29.9313C51.3627 30.4395 51.7744 31.1053 51.7784 31.7712C51.7703 32.2181 51.5806 32.6649 51.2093 33.0679Z",
    fill: "#A8CFF0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7919 27.2721L42.1178 25.533C42.0371 25.5592 42.0573 25.5987 41.9766 25.6293L42.5578 27.386C42.6345 27.351 42.7112 27.3116 42.7919 27.2721Z",
    fill: "#A8CFF0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6605 29.9838L39.2276 30.9695C39.1671 31.2367 39.1348 31.504 39.1388 31.7756C39.1348 32.0078 39.163 32.2356 39.2074 32.4634L39.4294 32.3801C39.3689 32.1129 39.3366 31.8457 39.3406 31.5784C39.3366 31.3112 39.3689 31.0396 39.4294 30.7768L36.8624 29.7911C36.8664 29.7823 36.8745 29.7692 36.8785 29.7604L36.8462 29.7473C37.0682 29.204 37.4032 28.6784 37.8351 28.1789L37.8068 28.1746C37.2862 28.7353 36.9027 29.3311 36.6484 29.9444L36.6807 29.9575C36.6686 29.9619 36.6646 29.9707 36.6605 29.9838Z",
    fill: "#A8CFF0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6762 34.7239C54.4219 34.9385 54.1515 35.1488 53.8367 35.3459C53.5259 35.5431 53.1909 35.7139 52.8438 35.8716L52.876 35.9549C53.1384 35.8278 53.3967 35.6964 53.6349 35.5431C53.9456 35.3459 54.2201 35.1357 54.4744 34.921L57.433 35.3722C57.4935 35.3065 57.546 35.2364 57.6065 35.1707L54.6762 34.7239Z",
    fill: "#A8CFF0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7352 38.4519L50.715 38.43C50.6989 38.4344 50.6827 38.4344 50.6666 38.4388L49.0965 36.8311C48.6727 36.8705 48.2448 36.888 47.817 36.888C47.3891 36.888 46.9613 36.8705 46.5375 36.8311L46.3438 37.0282C46.7676 37.0676 47.1914 37.0851 47.6152 37.0851C48.043 37.0851 48.4709 37.0676 48.8947 37.0282L50.4648 38.6359C50.4809 38.6316 50.4971 38.6316 50.5132 38.6272L50.5334 38.6491C51.5142 38.4914 52.4627 38.2504 53.3588 37.9219L53.3144 37.808C52.491 38.0883 51.6272 38.3074 50.7352 38.4519Z",
    fill: "#A8CFF0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M44.919 38.43L44.8988 38.4519C43.918 38.2942 42.9695 38.0533 42.0734 37.7247L42.7919 35.8716C42.4448 35.7139 42.1098 35.5431 41.799 35.3459C41.4882 35.1488 41.2137 34.9385 40.9594 34.7239L38.0008 35.1751C37.5003 34.6363 37.129 34.0624 36.8747 33.4753L36.6568 33.5586C36.6608 33.5673 36.6689 33.5805 36.6729 33.5892L36.6406 33.6024C36.8949 34.2157 37.2784 34.8115 37.799 35.3722L40.7576 34.921C41.0119 35.1357 41.2823 35.3459 41.5972 35.5431C41.9079 35.7402 42.243 35.9111 42.5901 36.0688L41.8716 37.9218C42.7677 38.246 43.7162 38.4914 44.697 38.6491L44.7172 38.6272C44.7333 38.6315 44.7495 38.6315 44.7656 38.6359L44.9594 38.4388C44.9473 38.4344 44.9311 38.4344 44.919 38.43Z",
    fill: "#A8CFF0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3298 41.2948C46.019 41.4393 45.7203 41.5927 45.4297 41.7548V38.9116L46.3298 41.2948Z",
    fill: "#2672AB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M49.749 58.0164L48.6875 59.0984L49.749 58.0164Z",
    fill: "url(#paint19_linear_2164_1087)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65.394 51.4452L61.5837 50.8669C61.2568 51.1473 60.9056 51.4189 60.5061 51.6686C60.1024 51.9227 59.6706 52.1418 59.2266 52.3433L60.1509 54.7308V55.2959C60.2679 55.2302 60.393 55.1645 60.5061 55.0944C60.9097 54.8403 61.2608 54.5731 61.5837 54.2927V50.8669L65.394 51.4452Z",
    fill: "#2672AB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4531 53.574L55.4501 54.5903L54.4531 53.574Z",
    fill: "url(#paint20_linear_2164_1087)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9141 54.4941L65.4004 54.8753L62.9141 54.4941Z",
    fill: "url(#paint21_linear_2164_1087)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4531 57.0044L55.4501 58.0164L54.4531 57.0044Z",
    fill: "url(#paint22_linear_2164_1087)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5106 55.6683L55.4531 54.5906L56.5106 55.6683Z",
    fill: "url(#paint23_linear_2164_1087)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5076 55.668L55.4501 54.5903L54.4531 53.574V57.0041L55.4501 58.0161L56.5076 59.0982V55.668Z",
    fill: "url(#paint24_linear_2164_1087)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5076 55.668L55.4501 54.5903L54.4531 53.574V57.0041L55.4501 58.0161L56.5076 59.0982V55.668Z",
    fill: "#2672AB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1563 54.7307C59.002 55.1513 57.779 55.4623 56.5156 55.6682V59.094V59.1027L56.6609 59.0677C57.8234 58.8706 58.9535 58.5814 60.0231 58.2003L60.1563 58.1653V55.2915V54.7307Z",
    fill: "url(#paint25_linear_2164_1087)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1563 54.7307C59.002 55.1513 57.779 55.4623 56.5156 55.6682V59.094V59.1027L56.6609 59.0677C57.8234 58.8706 58.9535 58.5814 60.0231 58.2003L60.1563 58.1653V55.2915V54.7307Z",
    fill: "#3F92D1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5859 54.2925L62.9098 54.494L61.5859 54.2925Z",
    fill: "url(#paint26_linear_2164_1087)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3962 51.4452L61.5859 50.8669V54.2927L62.9098 54.4942L65.3962 54.8754V51.4452Z",
    fill: "url(#paint27_linear_2164_1087)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3962 51.4452L61.5859 50.8669V54.2927L62.9098 54.4942L65.3962 54.8754V51.4452Z",
    fill: "#3F92D1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8919 49.1626C66.5649 49.9511 66.0685 50.7222 65.3984 51.445V54.8708C66.0685 54.1479 66.5649 53.3813 66.8919 52.5884V49.1626Z",
    fill: "url(#paint28_linear_2164_1087)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8919 49.1626C66.5649 49.9511 66.0685 50.7222 65.3984 51.445V54.8708C66.0685 54.1479 66.5649 53.3813 66.8919 52.5884V49.1626Z",
    fill: "#2672AB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5391 45.7809L63.5633 45.9124C63.7086 46.5651 63.7046 47.2266 63.5471 47.8793L65.2706 48.5452L66.8609 47.9363V44.5105L63.5391 45.7809Z",
    fill: "#2672AB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1797 41.2948C59.4905 41.4393 59.7892 41.5927 60.0798 41.7548V38.9116L59.1797 41.2948Z",
    fill: "#2672AB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8635 49.11L63.5538 47.8396C63.6345 47.4979 63.6708 47.1518 63.6708 46.8057C63.6748 46.4596 63.6345 46.1135 63.5578 45.7718L66.8675 44.5014C66.8635 44.4883 66.8554 44.4751 66.8473 44.462L66.8877 44.4444C66.5608 43.6515 66.0643 42.8849 65.3943 42.1621L61.5841 42.7403C61.2571 42.4599 60.906 42.1883 60.5064 41.9386C60.1027 41.6845 59.6709 41.4655 59.2269 41.264L60.1512 38.8765C58.9968 38.4559 57.7738 38.1449 56.5105 37.939L56.4863 37.9653C56.4661 37.9609 56.4459 37.9565 56.4217 37.9521L54.3955 40.0286C53.8465 39.9804 53.2976 39.9541 52.7446 39.9585C52.1917 39.9585 51.6427 39.9804 51.0938 40.0286L49.0676 37.9521C49.0474 37.9565 49.0272 37.9609 49.003 37.9653L48.9788 37.939C47.7155 38.1449 46.4925 38.4559 45.3381 38.8765L46.2624 41.264C45.8184 41.4699 45.3865 41.6889 44.9829 41.9386C44.5793 42.1927 44.2281 42.4599 43.9052 42.7403L40.095 42.1621C39.425 42.8849 38.9285 43.6515 38.6016 44.4444L38.6419 44.462C38.6379 44.4751 38.6298 44.4883 38.6217 44.5014L41.9315 45.7718C41.8508 46.1135 41.8144 46.4596 41.8185 46.8057C41.8144 47.1518 41.8548 47.4979 41.9355 47.8396L38.6258 49.11C38.6298 49.1231 38.6379 49.1363 38.646 49.1494L38.6056 49.1669C38.9325 49.9555 39.429 50.7265 40.099 51.4493L43.9093 50.8711C44.2362 51.1514 44.5873 51.4231 44.9869 51.6728C45.3906 51.9268 45.8224 52.1459 46.2664 52.3474L45.3421 54.7349C46.4965 55.1555 47.7195 55.4665 48.9828 55.6724L49.0071 55.6461C49.0272 55.6505 49.0474 55.6549 49.0676 55.6593L51.0898 53.5828C51.6387 53.631 52.1876 53.6573 52.7406 53.6529C53.2936 53.6529 53.8425 53.631 54.3914 53.5828L56.4136 55.6593C56.4338 55.6549 56.454 55.6505 56.4741 55.6461L56.4984 55.6724C57.7617 55.4665 58.9847 55.1555 60.1391 54.7349L59.2148 52.3474C59.6588 52.1415 60.0906 51.9225 60.4943 51.6728C60.8979 51.4187 61.249 51.1514 61.5719 50.8711L65.3822 51.4493C66.0522 50.7265 66.5487 49.9599 66.8756 49.1669L66.8352 49.1494C66.8514 49.1363 66.8595 49.1231 66.8635 49.11ZM56.5266 49.1757C55.4812 49.8328 54.1129 50.1614 52.7487 50.1658C51.3804 50.1614 50.0161 49.8284 48.9707 49.1757C47.9253 48.5186 47.3966 47.6643 47.3885 46.8101C47.3966 45.9514 47.9253 45.0972 48.9707 44.4401C50.0161 43.7829 51.3844 43.4544 52.7487 43.45C54.117 43.4544 55.4812 43.7873 56.5266 44.4401C57.572 45.0972 58.1008 45.9514 58.1088 46.8101C58.0967 47.6643 57.572 48.5186 56.5266 49.1757Z",
    fill: "#72B5E8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1016 51.4452L43.9118 50.8669C44.2387 51.1473 44.5899 51.4189 44.9895 51.6686C45.3931 51.9227 45.825 52.1418 46.269 52.3433L45.3447 54.7308V55.2959C45.2276 55.2302 45.1025 55.1645 44.9895 55.0944C44.5859 54.8403 44.2347 54.5731 43.9118 54.2927V50.8669L40.1016 51.4452Z",
    fill: "#3F92D1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3851 53.5832V53.5701C53.8402 53.6226 53.2913 53.6489 52.7464 53.6533C52.1975 53.6533 51.6485 53.6226 51.1077 53.5701V53.5832C51.0835 53.5832 51.0633 53.5788 51.0391 53.5788V57.0046C51.6041 57.0572 52.1773 57.0835 52.7464 57.0791C53.3155 57.0791 53.8887 57.0572 54.4537 57.0046V53.5788C54.4336 53.5788 54.4093 53.5788 54.3851 53.5832Z",
    fill: "#3F92D1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M51.032 53.574L50.0391 54.5903L51.032 53.574Z",
    fill: "url(#paint29_linear_2164_1087)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5879 54.4941L40.1016 54.8753L42.5879 54.4941Z",
    fill: "url(#paint30_linear_2164_1087)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M51.032 57.0044L50.0391 58.0164L51.032 57.0044Z",
    fill: "url(#paint31_linear_2164_1087)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9844 55.6683L50.0459 54.5906L48.9844 55.6683Z",
    fill: "url(#paint32_linear_2164_1087)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9844 55.668L50.0459 54.5903L51.0388 53.574V57.0041L50.0459 58.0161L48.9844 59.0982V55.668Z",
    fill: "url(#paint33_linear_2164_1087)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9844 55.668L50.0459 54.5903L51.0388 53.574V57.0041L50.0459 58.0161L48.9844 59.0982V55.668Z",
    fill: "#2672AB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3516 54.7307C46.5059 55.1513 47.7289 55.4623 48.9923 55.6682V59.094V59.1027L48.847 59.0677C47.6845 58.8706 46.5544 58.5814 45.4848 58.2003L45.3516 58.1653V55.2915V54.7307Z",
    fill: "url(#paint34_linear_2164_1087)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3516 54.7307C46.5059 55.1513 47.7289 55.4623 48.9923 55.6682V59.094V59.1027L48.847 59.0677C47.6845 58.8706 46.5544 58.5814 45.4848 58.2003L45.3516 58.1653V55.2915V54.7307Z",
    fill: "#3F92D1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9098 54.2925L42.5859 54.494L43.9098 54.2925Z",
    fill: "url(#paint35_linear_2164_1087)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1016 51.4452L43.9118 50.8669V54.2927L42.5879 54.4942L40.1016 54.8754V51.4452Z",
    fill: "url(#paint36_linear_2164_1087)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1016 51.4452L43.9118 50.8669V54.2927L42.5879 54.4942L40.1016 54.8754V51.4452Z",
    fill: "#2672AB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6016 49.1626C38.9285 49.9511 39.425 50.7222 40.095 51.445V54.8708C39.425 54.1479 38.9285 53.3813 38.6016 52.5884V49.1626Z",
    fill: "url(#paint37_linear_2164_1087)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6016 49.1626C38.9285 49.9511 39.425 50.7222 40.095 51.445V54.8708C39.425 54.1479 38.9285 53.3813 38.6016 52.5884V49.1626Z",
    fill: "#3F92D1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9547 45.7809L41.9304 45.9124C41.7851 46.5651 41.7892 47.2266 41.9466 47.8793L40.2231 48.5452L38.6328 47.9363V44.5105L41.9547 45.7809Z",
    fill: "#2672AB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5529 44.4228C55.5034 43.7656 54.1271 43.4415 52.7507 43.4458C51.3743 43.4415 49.9939 43.7656 48.9486 44.4228C47.9072 45.0755 47.3946 45.9298 47.3986 46.7884C47.3906 47.3929 47.6368 48.0019 48.1453 48.5363C48.3714 48.2954 48.6418 48.0676 48.9728 47.8617C50.0182 47.2046 51.3865 46.876 52.7507 46.8716C54.119 46.876 55.4833 47.2089 56.5287 47.8617C56.8556 48.0676 57.1301 48.2954 57.3561 48.5363C57.8687 48.0019 58.1149 47.3929 58.1028 46.7884C58.1068 45.9298 57.5942 45.0755 56.5529 44.4228Z",
    fill: "#2672AB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5824 39.8359L56.3584 38.0178C56.3584 38.0178 56.3503 38.0178 56.3463 38.0178L54.5703 39.8402C54.5743 39.8359 54.5784 39.8359 54.5824 39.8359Z",
    fill: "#A8CFF0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7626 45.7193L66.7898 44.5584C66.7858 44.5452 66.7777 44.5321 66.7696 44.5189L66.81 44.5014C66.7979 44.4708 66.7818 44.4401 66.7656 44.4094L63.7344 45.5703C63.7505 45.6229 63.7546 45.6711 63.7626 45.7193Z",
    fill: "#A8CFF0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2975 48.5362C57.9473 47.9579 58.2823 47.2876 58.2904 46.613C58.2823 45.7544 57.7536 44.9001 56.7082 44.243C55.6628 43.5859 54.2945 43.2573 52.9302 43.2529C51.5619 43.2573 50.1977 43.5902 49.1523 44.243C48.8133 44.4576 48.5348 44.6898 48.3047 44.9395C48.4782 44.7862 48.672 44.6373 48.894 44.4971C49.9394 43.84 51.3077 43.5114 52.6719 43.507C54.0402 43.5114 55.4045 43.8443 56.4499 44.4971C57.4953 45.1542 58.024 46.0085 58.0321 46.8671C58.028 47.441 57.7778 48.0192 57.2975 48.5362Z",
    fill: "#A8CFF0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4479 41.0714L45.5801 38.8328C45.4751 38.8678 45.5034 38.916 45.3984 38.9554L46.1451 41.2203C46.2461 41.1677 46.347 41.1195 46.4479 41.0714Z",
    fill: "#A8CFF0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5477 44.5586L41.8574 45.829C41.7767 46.1707 41.7403 46.5168 41.7444 46.8629C41.7403 47.1608 41.7767 47.4543 41.8332 47.7522L42.1157 47.6427C42.035 47.301 41.9987 46.9549 41.9987 46.6088C41.9946 46.2627 42.035 45.9166 42.1117 45.5749L38.8019 44.3045C38.806 44.2914 38.814 44.2782 38.8221 44.2651L38.7818 44.2475C39.0683 43.551 39.5002 42.872 40.0532 42.2236L40.0169 42.2192C39.3468 42.9421 38.8504 43.7087 38.5234 44.5016L38.5638 44.5192C38.5598 44.5323 38.5517 44.5454 38.5477 44.5586Z",
    fill: "#A8CFF0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7634 50.6697C61.4365 50.95 61.0853 51.2217 60.6857 51.4714C60.2821 51.7254 59.8502 51.9445 59.4062 52.146L59.4466 52.2511C59.7857 52.0891 60.1166 51.9138 60.4234 51.7211C60.827 51.467 61.1782 51.1998 61.5011 50.9194L65.3113 51.4976C65.392 51.4144 65.4606 51.3268 65.5333 51.2392L61.7634 50.6697Z",
    fill: "#A8CFF0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6861 55.4707L56.6618 55.4445C56.6417 55.4488 56.6215 55.4532 56.6013 55.4576L54.5791 53.3811C54.0302 53.4293 53.4813 53.4556 52.9283 53.4512C52.3753 53.4512 51.8264 53.4293 51.2775 53.3811L51.0312 53.6352C51.5761 53.6834 52.121 53.7097 52.67 53.7053C53.2229 53.7053 53.7719 53.6834 54.3208 53.6352L56.343 55.7117C56.3632 55.7073 56.3833 55.7029 56.4035 55.6985L56.4277 55.7248C57.6911 55.5189 58.9141 55.2079 60.0684 54.7873L60.0119 54.6384C58.9504 55.0064 57.8364 55.2868 56.6861 55.4707Z",
    fill: "#A8CFF0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1832 55.4448L49.159 55.4711C47.8956 55.2652 46.6727 54.9542 45.5183 54.5336L46.4426 52.1461C45.9986 51.9402 45.5667 51.7211 45.1631 51.4714C44.7595 51.2173 44.4083 50.9501 44.0854 50.6698L40.2752 51.248C39.6294 50.5558 39.1491 49.8155 38.8221 49.0576L38.5436 49.1628C38.5477 49.1759 38.5557 49.189 38.5638 49.2022L38.5234 49.2197C38.8504 50.0082 39.3468 50.7793 40.0169 51.5021L43.8271 50.9238C44.154 51.2042 44.5052 51.4758 44.9048 51.7255C45.3084 51.9796 45.7403 52.1986 46.1843 52.4002L45.26 54.7877C46.4143 55.2083 47.6373 55.5193 48.9007 55.7252L48.9249 55.6989C48.9451 55.7033 48.9653 55.7077 48.9854 55.712L49.2357 55.458C49.2195 55.4536 49.2034 55.4492 49.1832 55.4448Z",
    fill: "#A8CFF0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M112.613 19.382L83.8753 1.37254C80.6342 -0.660147 74.9713 -0.406061 71.2297 1.94205L3.65051 44.2868C-0.0911107 46.6305 -0.498773 50.179 2.74235 52.2117L31.4805 70.2211C34.7217 72.2538 40.3845 71.9997 44.1262 69.6516L111.701 27.3069C115.451 24.9631 115.855 21.4147 112.613 19.382ZM109.635 26.1678L42.3139 68.3549C39.5692 70.0766 35.4119 70.2649 33.0345 68.7711L5.05916 51.2391C2.6818 49.7497 2.98049 47.1431 5.72515 45.4258L73.046 3.23876C75.7907 1.51711 79.948 1.32873 82.3254 2.82259L110.301 20.3545C112.682 21.844 112.383 24.4462 109.635 26.1678Z",
    fill: "#D1EBFF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M114.801 22.6326C114.797 22.453 114.781 22.3347 114.749 22.2559C115.039 23.9731 114.002 25.8656 111.705 27.3069L44.1302 69.6517C40.3886 71.9954 34.7257 72.2539 31.4846 70.2212L2.74638 52.2117C1.34983 51.3356 0.631377 50.1747 0.566796 48.9524C0.554688 49.4781 0.554688 51.3969 0.554688 51.4977C0.574869 52.7681 1.29332 53.9772 2.74234 54.8884L31.4805 72.8979C34.7217 74.9305 40.3845 74.6765 44.1262 72.3284L111.701 29.9836C113.627 28.7745 114.672 27.25 114.785 25.778C114.801 25.6597 114.805 22.7465 114.801 22.6326Z",
    fill: "#2672AB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74279 51.8613L31.481 69.8708C34.7221 71.9034 40.385 71.6494 44.1266 69.3012L111.702 26.9565C113.671 25.7211 114.717 24.1528 114.794 22.6501C114.874 24.2579 113.825 25.9752 111.702 27.3069L44.1266 69.6517C40.385 71.9954 34.7221 72.2539 31.481 70.2212L2.74279 52.2118C1.20901 51.248 0.490555 49.9469 0.559172 48.5932C0.623752 49.8198 1.34221 50.9851 2.74279 51.8613Z",
    fill: "#A8CFF0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M109.999 20.9241L82.0232 3.39214C81.0787 2.80073 79.7548 2.47217 78.2937 2.47217C76.5056 2.47217 74.7014 2.95844 73.3452 3.80831L42.6494 23.0444L77.9062 45.2901L109.333 25.5984C110.584 24.8142 111.302 23.8242 111.302 22.8779C111.302 21.936 110.592 21.2964 109.999 20.9241ZM6.02438 45.9954C4.77314 46.7795 4.05469 47.7696 4.05469 48.7159C4.05469 49.6577 4.76507 50.3017 5.3584 50.6741L33.3337 68.206C34.2782 68.7974 35.6021 69.126 37.0633 69.126C38.8513 69.126 40.6555 68.6397 42.0117 67.7898L56.9661 58.4193L21.7093 36.1693L6.02438 45.9954Z",
    fill: "#03336E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6497 23.0444L77.9065 45.2901V45.6055L42.6094 23.373L42.6497 23.0444Z",
    fill: "#2672AB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9951 14.4316L74.9496 18.7905C76.8708 19.9952 80.229 19.8419 82.4449 18.4532L88.2369 14.8215C90.4569 13.4328 90.695 11.33 88.7738 10.1253L81.8193 5.76642C79.898 4.5617 76.5439 4.71503 74.3239 6.10374L68.5319 9.73542C66.312 11.1241 66.0698 13.2269 67.9951 14.4316Z",
    fill: "#084C94"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M105.272 20.4771L98.3176 16.1182C96.3964 14.9135 93.0382 15.0668 90.8223 16.4556L85.0303 20.0872C82.8103 21.4759 82.5722 23.5787 84.4934 24.7834L91.4479 29.1423C93.3692 30.3471 96.7273 30.1937 98.9433 28.805L104.735 25.1733C106.951 23.7846 107.193 21.6818 105.272 20.4771Z",
    fill: "#084C94"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5077 24.7266L58.4622 29.0855C60.3834 30.2902 63.7416 30.1368 65.9575 28.7481L71.7496 25.1165C73.9695 23.7277 74.2076 21.625 72.2864 20.4202L65.3319 16.0613C63.4106 14.8566 60.0565 15.01 57.8366 16.3987L52.0445 20.0303C49.8286 21.4191 49.5864 23.5218 51.5077 24.7266Z",
    fill: "#084C94"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7956 30.772L81.8411 26.4132C79.9198 25.2084 76.5616 25.3618 74.3457 26.7505L68.5537 30.3822C66.3337 31.7709 66.0956 33.8736 68.0169 35.0784L74.9714 39.4373C76.8926 40.642 80.2508 40.4886 82.4667 39.0999L88.2587 35.4683C90.4746 34.0795 90.7168 31.9768 88.7956 30.772Z",
    fill: "#084C94"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2643 46.0479L24.3098 41.689C22.3886 40.4843 19.0344 40.6376 16.8145 42.0264L11.0224 45.658C8.8025 47.0467 8.56436 49.1495 10.4856 50.3542L17.4401 54.7131C19.3614 55.9179 22.7195 55.7645 24.9354 54.3758L30.7275 50.7441C32.9474 49.3554 33.1896 47.2526 31.2643 46.0479Z",
    fill: "#084C94"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7565 56.3997L40.802 52.0408C38.8807 50.8361 35.5226 50.9894 33.3067 52.3782L27.5146 56.0098C25.2947 57.3986 25.0565 59.5013 26.9778 60.7061L33.9323 65.0649C35.8536 66.2697 39.2117 66.1163 41.4276 64.7276L47.2197 61.0959C49.4356 59.7072 49.6778 57.6045 47.7565 56.3997Z",
    fill: "#084C94"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5263 10.9401L74.3183 7.30846C76.5383 5.91975 79.8924 5.76642 81.8137 6.97114L88.7682 11.33C89.4099 11.7331 89.8055 12.2369 89.971 12.7801C90.2575 11.8032 89.8701 10.8175 88.7682 10.1253L81.8137 5.76642C79.8924 4.5617 76.5383 4.71503 74.3183 6.10374L68.5263 9.73542C67.049 10.6598 66.4557 11.8995 66.7826 12.9816C66.9966 12.2544 67.5778 11.5315 68.5263 10.9401Z",
    fill: "#001A46"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2844 23.3334C83.4984 22.6062 84.0796 21.8834 85.0241 21.2919L90.8161 17.6603C93.036 16.2716 96.3902 16.1182 98.3114 17.3229L105.266 21.6818C105.908 22.0849 106.303 22.5887 106.469 23.1319C106.755 22.155 106.368 21.1693 105.266 20.4771L98.3114 16.1182C96.3902 14.9135 93.032 15.0668 90.8161 16.4556L85.0241 20.0872C83.5468 21.0116 82.9535 22.2513 83.2844 23.3334Z",
    fill: "#001A46"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0475 21.2351L57.8395 17.6034C60.0595 16.2147 63.4136 16.0613 65.3349 17.2661L72.2894 21.625C72.9311 22.028 73.3267 22.5318 73.4922 23.075C73.7787 22.0981 73.3913 21.1124 72.2894 20.4202L65.3349 16.0613C63.4136 14.8566 60.0595 15.01 57.8395 16.3987L52.0475 20.0303C50.5702 20.9547 49.9769 22.1945 50.3079 23.2765C50.5178 22.5493 51.099 21.8265 52.0475 21.2351Z",
    fill: "#001A46"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0185 46.8627L16.8105 43.2311C19.0305 41.8424 22.3846 41.689 24.3059 42.8937L31.2603 47.2526C31.9021 47.6557 32.2977 48.1595 32.4632 48.7027C32.7497 47.7258 32.3623 46.7401 31.2603 46.0479L24.3059 41.689C22.3846 40.4843 19.0305 40.6376 16.8105 42.0264L11.0185 45.658C9.54121 46.5824 8.94788 47.8221 9.27482 48.9042C9.48874 48.177 10.07 47.4542 11.0185 46.8627Z",
    fill: "#001A46"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7894 30.772L81.8349 26.4132C79.9136 25.2084 76.5554 25.3618 74.3395 26.7505L68.5475 30.3822C67.0702 31.3065 66.4769 32.5463 66.8079 33.6283C67.0218 32.9011 67.603 32.1783 68.5475 31.5869L74.3395 27.9552C76.5595 26.5665 79.9136 26.4132 81.8349 27.6179L88.7894 31.9768C89.4311 32.3798 89.8267 32.8836 89.9922 33.4268C90.2787 32.4499 89.8913 31.4642 88.7894 30.772Z",
    fill: "#001A46"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7503 56.3997L40.7958 52.0408C38.8746 50.8361 35.5164 50.9894 33.3005 52.3782L27.5084 56.0098C26.0312 56.9342 25.4378 58.1739 25.7688 59.256C25.9827 58.5288 26.564 57.806 27.5084 57.2146L33.3005 53.5829C35.5204 52.1942 38.8746 52.0408 40.7958 53.2456L47.7503 57.6045C48.3921 58.0075 48.7876 58.5113 48.9531 59.0545C49.2397 58.0776 48.8522 57.0919 47.7503 56.3997Z",
    fill: "#001A46"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0223 17.5682L68.1163 13.2399C66.2071 12.044 66.4493 9.95435 68.649 8.5744L74.4007 4.969C76.6045 3.58905 79.9385 3.4401 81.8436 4.63606L88.7496 8.96429C90.6588 10.1602 90.4166 12.2499 88.2169 13.6298L82.4652 17.2352C80.2654 18.6152 76.9315 18.7641 75.0223 17.5682Z",
    fill: "#72B5E8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8325 11.0847L66.8281 11.1803C66.8281 11.1499 66.8281 11.1195 66.8325 11.0847Z",
    fill: "#D62D69"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2166 13.63L82.465 17.2354C80.2612 18.6153 76.9272 18.7643 75.0221 17.5683L68.116 13.2401C67.2967 12.7275 66.8729 12.0441 66.8325 11.33V12.3771C66.78 13.1831 67.1998 13.9629 68.116 14.5368L75.0221 18.865C76.9312 20.061 80.2652 19.912 82.465 18.5321L88.2166 14.9267C89.3549 14.2126 89.9684 13.3102 90.0329 12.4384V12.4209C90.037 12.3332 90.037 12.2412 90.0329 12.1536V11.0847H90.0289C89.9885 11.974 89.3791 12.9027 88.2166 13.63Z",
    fill: "#2672AB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8325 11.0847L66.8281 11.1803C66.8281 11.1499 66.8281 11.1195 66.8325 11.0847Z",
    fill: "#D62D69"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0221 17.5683L68.116 13.2401C67.2967 12.7276 66.8729 12.0441 66.8325 11.3301V12.3771C66.78 13.1832 67.1998 13.9629 68.116 14.5368L75.0221 18.865V17.5683Z",
    fill: "#3F92D1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2193 13.3013L82.4676 16.9067C80.2638 18.2867 76.9298 18.4356 75.0247 17.2397L68.1187 12.9114C67.3155 12.4077 66.8957 11.7462 66.8432 11.0452C66.7746 11.8644 67.1903 12.6574 68.1187 13.24L75.0247 17.5682C76.9339 18.7642 80.2678 18.6152 82.4676 17.2353L88.2193 13.6299C89.4947 12.8326 90.1082 11.7943 90.0316 10.8306C89.9589 11.698 89.3494 12.5916 88.2193 13.3013Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9526 11.0541L77.8295 7.21655C77.4542 6.97998 76.8447 6.97998 76.4734 7.21217L72.8811 9.4639C72.5057 9.69608 72.5097 10.0772 72.8851 10.3138L76.7115 12.7101L76.7236 15.102L78.6247 13.9104L79.0081 14.1513C79.3835 14.3879 79.993 14.3879 80.3643 14.1557L83.9566 11.904C84.332 11.6674 84.332 11.2863 83.9526 11.0541ZM76.8084 10.121C76.4128 10.121 76.0899 9.9195 76.0859 9.66979C76.0859 9.42009 76.4047 9.21857 76.8043 9.21857C77.1999 9.21857 77.5228 9.42009 77.5268 9.66979C77.5268 9.9195 77.2039 10.121 76.8084 10.121ZM78.4673 11.1593C78.0717 11.1593 77.7488 10.9577 77.7448 10.708C77.7448 10.4583 78.0636 10.2568 78.4632 10.2568C78.8588 10.2568 79.1817 10.4583 79.1857 10.708C79.1857 10.9577 78.8628 11.1593 78.4673 11.1593ZM80.1262 12.1975C79.7306 12.1975 79.4077 11.996 79.4037 11.7463C79.3996 11.4966 79.7225 11.2951 80.1221 11.2951C80.5177 11.2951 80.8406 11.4966 80.8446 11.7463C80.8406 12.0004 80.5217 12.2019 80.1262 12.1975Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4676 27.8282L84.5616 23.5C82.6524 22.304 82.8946 20.2144 85.0944 18.8344L90.846 15.229C93.0498 13.8491 96.3838 13.7001 98.2889 14.8961L105.195 19.2243C107.104 20.4203 106.862 22.5099 104.662 23.8898L98.9105 27.4952C96.7107 28.8752 93.3768 29.0241 91.4676 27.8282Z",
    fill: "#3ECFCD"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2778 21.3447L83.2734 21.4403C83.2734 21.4099 83.2734 21.3751 83.2778 21.3447Z",
    fill: "#D62D69"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M104.662 23.89L98.9103 27.4954C96.7065 28.8753 93.3725 29.0243 91.4674 27.8283L84.5613 23.5001C83.742 22.9875 83.3182 22.3041 83.2778 21.5901V22.6371C83.2253 23.4431 83.6451 24.2229 84.5613 24.7968L91.4674 29.125C93.3765 30.321 96.7105 30.172 98.9103 28.7921L104.662 25.1867C105.8 24.4726 106.414 23.5702 106.478 22.6984V22.6809C106.482 22.5933 106.482 22.5013 106.478 22.4136V21.3447H106.474C106.434 22.234 105.824 23.1584 104.662 23.89Z",
    fill: "#0BA19F"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2778 21.3447L83.2734 21.4403C83.2734 21.4099 83.2734 21.3751 83.2778 21.3447Z",
    fill: "#D62D69"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4674 27.8283L84.5613 23.5001C83.742 22.9876 83.3182 22.3042 83.2778 21.5901V22.6371C83.2253 23.4432 83.6451 24.2229 84.5613 24.7968L91.4674 29.1251V27.8283Z",
    fill: "#0FBAB8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M104.665 23.5613L98.9129 27.1667C96.7091 28.5467 93.3752 28.6956 91.47 27.4997L84.564 23.1715C83.7608 22.6677 83.341 22.0062 83.2885 21.3052C83.2199 22.1244 83.6356 22.9174 84.564 23.5L91.47 27.8282C93.3792 29.0242 96.7131 28.8753 98.9129 27.4953L104.665 23.8899C105.94 23.0926 106.554 22.0544 106.477 21.0906C106.404 21.9536 105.795 22.8517 104.665 23.5613Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5067 21.9141L51.6006 17.5859C49.6915 16.3899 49.9337 14.3003 52.1334 12.9203L57.8851 9.31495C60.0889 7.935 63.4229 7.78605 65.328 8.98201L72.234 13.3102C74.1432 14.5062 73.901 16.5958 71.7012 17.9758L65.9496 21.5812C63.7458 22.9611 60.4118 23.1101 58.5067 21.9141Z",
    fill: "#F76195"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3168 15.4304L50.3125 15.526C50.3168 15.4956 50.3168 15.4608 50.3168 15.4304Z",
    fill: "#D62D69"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M71.701 17.9757L65.9493 21.5811C63.7455 22.961 60.4116 23.11 58.5065 21.914L51.6004 17.5858C50.781 17.0732 50.3572 16.3898 50.3169 15.6757V18.0545C50.2644 18.8606 50.6842 19.6404 51.6004 20.2142L58.5065 24.5425C60.4156 25.7384 63.7496 25.5895 65.9493 24.2095L71.701 20.6041C72.8392 19.8901 73.4527 18.9876 73.5173 18.1158V18.0983C73.5214 18.0107 73.5214 17.9187 73.5173 17.8311V15.4304H73.5133C73.477 16.3197 72.8634 17.2441 71.701 17.9757Z",
    fill: "#D62D69"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3168 15.4304L50.3125 15.526C50.3168 15.4956 50.3168 15.4608 50.3168 15.4304Z",
    fill: "#D62D69"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5065 21.914L51.6004 17.5858C50.781 17.0733 50.3572 16.3899 50.3169 15.6758V18.0546C50.2644 18.8606 50.6842 19.6404 51.6004 20.2143L58.5065 24.5425V21.914Z",
    fill: "#EB4680"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7115 17.6473L65.9598 21.2527C63.756 22.6326 60.422 22.7816 58.5169 21.5856L51.6109 17.2574C50.8076 16.7536 50.3879 16.0921 50.3354 15.3912C50.2668 16.2104 50.6825 17.0033 51.6109 17.586L58.5169 21.9142C60.4261 23.1101 63.76 22.9612 65.9598 21.5812L71.7115 17.9758C72.9869 17.1785 73.6004 16.1403 73.5237 15.1765C73.4511 16.0395 72.8416 16.9376 71.7115 17.6473Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2131 19.2244L55.7359 15.7898C55.4533 15.6146 55.4533 15.3299 55.7318 15.1546L56.753 14.515C57.4028 14.1076 58.4038 14.0375 59.1909 14.3398C59.6712 14.5238 60.2161 14.6289 60.765 14.6377C60.874 14.6377 60.9749 14.6158 61.0556 14.5676C61.1404 14.515 61.1888 14.4449 61.1888 14.3705C61.1888 14.0726 61.2736 13.7791 61.427 13.5162C61.2776 13.3103 61.2655 13.0299 61.536 12.8635C61.7822 12.7101 62.1131 12.6401 62.3876 12.6839C63.6994 11.9698 64.9547 11.9829 66.1292 12.7189C67.3038 13.4549 67.3199 14.2434 66.1857 15.0626C66.2503 15.2335 66.1454 15.4394 65.8992 15.5971C65.6287 15.7679 65.1807 15.7592 64.8538 15.6672C64.434 15.7636 63.9658 15.8161 63.4936 15.8161C63.3765 15.8161 63.2594 15.8468 63.1787 15.8994C63.102 15.9476 63.0617 16.0133 63.0657 16.079C63.0778 16.4207 63.2433 16.7624 63.542 17.0647C64.0263 17.5553 63.9093 18.1861 63.2594 18.5936L62.2383 19.2332C61.9477 19.404 61.4916 19.404 61.2131 19.2244Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M100.614 22.0453L94.5316 18.234L95.1814 17.3754C95.2541 17.2834 95.2218 17.1695 95.1047 17.095L93.24 15.9253C93.0866 15.8289 92.8404 15.8289 92.687 15.9253C92.5336 16.0217 92.5336 16.175 92.687 16.2714L94.358 17.3184L90.6325 22.2468C90.5599 22.3388 90.5922 22.4527 90.7092 22.5272L91.3066 22.8995C91.2662 22.8952 91.2259 22.8908 91.1855 22.8908C90.6164 22.8908 90.1562 23.1799 90.1562 23.5348C90.1562 23.894 90.6204 24.1831 91.1895 24.1831C91.7586 24.1831 92.2188 23.894 92.2188 23.5391C92.2188 23.5129 92.2107 23.4866 92.2067 23.4647L93.4983 24.2751C93.4579 24.2707 93.4175 24.2663 93.3772 24.2663C92.8081 24.2663 92.3479 24.5555 92.3479 24.9103C92.3479 25.2696 92.8121 25.5587 93.3812 25.5587C93.9503 25.5587 94.4105 25.2695 94.4105 24.9147C94.4105 24.8884 94.4024 24.8621 94.3984 24.8359L94.6728 25.0067C94.8262 25.1031 95.0724 25.1031 95.2258 25.0067C95.3792 24.9103 95.3792 24.757 95.2258 24.6606L91.46 22.2994L92.2188 21.2962L96.6022 24.0429C97.0058 24.297 97.6314 24.3364 98.1077 24.1481L100.425 23.2106C101.066 22.9521 101.159 22.387 100.614 22.0453Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.7957 48.6898L31.8897 44.3615C29.9805 43.1656 30.2227 41.0759 32.4225 39.696L38.1742 36.0906C40.378 34.7106 43.7119 34.5617 45.617 35.7576L52.5231 40.0859C54.4322 41.2818 54.1901 43.3715 51.9903 44.7514L46.2386 48.3568C44.0389 49.7368 40.7049 49.8857 38.7957 48.6898Z",
    fill: "#92B4D1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.7411 56.3079L44.835 51.9797C42.9259 50.7837 43.168 48.6941 45.3678 47.3141L51.1195 43.7087C53.3233 42.3288 56.6572 42.1798 58.5623 43.3758L65.4684 47.704C67.3776 48.9 67.1354 50.9896 64.9356 52.3696L59.1839 55.975C56.9842 57.3549 53.6502 57.5039 51.7411 56.3079Z",
    fill: "#92B4D1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4676 52.2383L10.5616 47.9101C8.65242 46.7142 8.89459 44.6245 11.0944 43.2446L16.846 39.6392C19.0498 38.2592 22.3838 38.1103 24.2889 39.3062L31.195 43.6345C33.1041 44.8304 32.8619 46.92 30.6622 48.3L24.9105 51.9054C22.7067 53.2853 19.3768 53.4343 17.4676 52.2383Z",
    fill: "#72B5E8"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27778 45.7546L9.27344 45.8502C9.27344 45.8198 9.27344 45.7851 9.27778 45.7546Z",
    fill: "#D62D69"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6619 48.2955L24.9103 51.9009C22.7065 53.2808 19.3725 53.4298 17.4674 52.2338L10.5613 47.9056C9.74198 47.393 9.31817 46.7096 9.27781 45.9956V48.3743C9.22533 49.1804 9.64511 49.9602 10.5613 50.5341L17.4674 54.8623C19.3765 56.0583 22.7105 55.9093 24.9103 54.5294L30.6619 50.924C31.8002 50.2099 32.4137 49.3074 32.4783 48.4357V48.4181C32.4823 48.3305 32.4823 48.2385 32.4783 48.1509V45.7502H32.4742C32.4339 46.6439 31.8244 47.5683 30.6619 48.2955Z",
    fill: "#2672AB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27778 45.7546L9.27344 45.8502C9.27344 45.8198 9.27344 45.7851 9.27778 45.7546Z",
    fill: "#D62D69"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4674 52.2383L10.5613 47.91C9.74198 47.3975 9.31817 46.7141 9.27781 46V48.3788C9.22533 49.1848 9.64511 49.9646 10.5613 50.5385L17.4674 54.8667V52.2383Z",
    fill: "#3F92D1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6646 47.9671L24.9129 51.5725C22.7091 52.9525 19.3752 53.1014 17.47 51.9054L10.564 47.5772C9.76077 47.0734 9.341 46.4119 9.28853 45.711C9.21991 46.5302 9.63565 47.3231 10.564 47.9058L17.47 52.234C19.3792 53.43 22.7131 53.281 24.9129 51.9011L30.6646 48.2957C31.94 47.4984 32.5536 46.4601 32.4769 45.4963C32.4042 46.3637 31.7947 47.2618 30.6646 47.9671Z",
    fill: "#D1EBFF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M75.077 36.879L68.1709 32.5507C66.2618 31.3548 66.504 29.2651 68.7037 27.8852L74.4554 24.2798C76.6592 22.8998 79.9932 22.7509 81.8983 23.9469L88.8043 28.2751C90.7135 29.471 90.4713 31.5607 88.2715 32.9406L82.5199 36.546C80.3161 37.9216 76.9861 38.0749 75.077 36.879Z",
    fill: "#3ECFCD"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8872 30.3955L66.8828 30.4911C66.8828 30.4563 66.8828 30.4259 66.8872 30.3955Z",
    fill: "#D62D69"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2713 32.9364L82.5196 36.5418C80.3158 37.9217 76.9819 38.0706 75.0768 36.8747L68.1707 32.5465C67.3513 32.0339 66.9275 31.3505 66.8872 30.6364V33.0152C66.8347 33.8213 67.2545 34.6011 68.1707 35.1749L75.0768 39.5032C76.9859 40.6991 80.3199 40.5502 82.5196 39.1702L88.2713 35.5648C89.4095 34.8508 90.023 33.9483 90.0876 33.0765V33.059C90.0917 32.9714 90.0917 32.8794 90.0876 32.7918V30.3911H90.0836C90.0473 31.2848 89.4378 32.2091 88.2713 32.9364Z",
    fill: "#0BA19F"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8872 30.3955L66.8828 30.4911C66.8828 30.4563 66.8828 30.4259 66.8872 30.3955Z",
    fill: "#D62D69"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0768 36.8791L68.1707 32.5509C67.3513 32.0383 66.9275 31.3549 66.8872 30.6409V33.0196C66.8347 33.8257 67.2545 34.6055 68.1707 35.1794L75.0768 39.5076V36.8791Z",
    fill: "#0FBAB8"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M88.274 32.6077L82.5223 36.2131C80.3185 37.5931 76.9845 37.742 75.0794 36.5461L68.1734 32.2178C67.3701 31.714 66.9504 31.0525 66.8979 30.3516C66.8293 31.1708 67.245 31.9638 68.1734 32.5464L75.0794 36.8746C76.9886 38.0706 80.3225 37.9216 82.5223 36.5417L88.274 32.9363C89.5494 32.139 90.1629 31.1007 90.0862 30.137C90.0176 31.0044 89.4082 31.9024 88.274 32.6077Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M77.379 26.0056L77.9804 30.75L85.5565 31.1268V31.1311C85.5242 30.9822 85.4193 30.8376 85.2376 30.7237L78.0248 26.2071C77.8432 26.0932 77.6091 26.0275 77.375 26.0056C77.375 26.0056 77.375 26.0056 77.379 26.0056Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5552 31.1399L77.3817 31.1224L77.3737 29.6723L71.9489 29.4051C71.9489 29.4007 71.9489 29.3964 71.9449 29.392L77.3696 29.4007L77.3535 26.0012C77.0225 25.975 76.6794 26.0407 76.4251 26.1984L72.1951 28.8488C71.7552 29.1247 71.7592 29.5716 72.1992 29.8476L79.412 34.3642C79.856 34.6402 80.5704 34.6445 81.0103 34.3686L85.2403 31.7182C85.4906 31.5649 85.5955 31.3502 85.5552 31.1399ZM80.1224 34.5263L79.6945 31.1268H80.1304L80.1466 34.5263C80.1385 34.5306 80.1304 34.5306 80.1224 34.5263Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0547 45.8377L14.9679 47.0336L18.435 44.8608L16.5218 43.6648L13.0547 45.8377Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5469 47.3975L17.4601 48.5978L23.5346 44.7909L21.6215 43.5906L15.5469 47.3975Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7251 43.52L18.0391 48.961L19.9523 50.1613L28.6383 44.7204L26.7251 43.52Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2164_1087",
    x1: 45.3467,
    y1: 40.8451,
    x2: 44.5237,
    y2: 40.8451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2164_1087",
    x1: 49,
    y1: 37.3725,
    x2: 49.7722,
    y2: 37.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2164_1087",
    x1: 55.5695,
    y1: 37.8395,
    x2: 57.4991,
    y2: 37.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2164_1087",
    x1: 49,
    y1: 40.0328,
    x2: 49.7722,
    y2: 40.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2164_1087",
    x1: 49.7669,
    y1: 38.1847,
    x2: 50.59,
    y2: 38.1847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2164_1087",
    x1: 49,
    y1: 39.1217,
    x2: 50.5953,
    y2: 39.1217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2164_1087",
    x1: 50.5948,
    y1: 39.5744,
    x2: 53.4201,
    y2: 39.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2164_1087",
    x1: 54.5395,
    y1: 37.6145,
    x2: 55.5675,
    y2: 37.6145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2164_1087",
    x1: 54.5395,
    y1: 36.4312,
    x2: 57.4971,
    y2: 36.4312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2164_1087",
    x1: 57.4994,
    y1: 35.7707,
    x2: 58.6595,
    y2: 35.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2164_1087",
    x1: 46.3427,
    y1: 37.3725,
    x2: 45.5706,
    y2: 37.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2164_1087",
    x1: 39.7869,
    y1: 37.8395,
    x2: 37.8574,
    y2: 37.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2164_1087",
    x1: 46.3427,
    y1: 40.0328,
    x2: 45.5706,
    y2: 40.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2164_1087",
    x1: 45.5815,
    y1: 38.1847,
    x2: 44.7583,
    y2: 38.1847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2164_1087",
    x1: 46.3536,
    y1: 39.1217,
    x2: 44.7583,
    y2: 39.1217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2164_1087",
    x1: 44.7556,
    y1: 39.5744,
    x2: 41.9301,
    y2: 39.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2164_1087",
    x1: 40.8152,
    y1: 37.6145,
    x2: 39.7873,
    y2: 37.6145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2164_1087",
    x1: 40.8148,
    y1: 36.4312,
    x2: 37.8574,
    y2: 36.4312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2164_1087",
    x1: 37.8558,
    y1: 35.7707,
    x2: 36.6958,
    y2: 35.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2164_1087",
    x1: 49.7479,
    y1: 58.5569,
    x2: 48.6876,
    y2: 58.5569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2164_1087",
    x1: 54.4537,
    y1: 54.0825,
    x2: 55.4486,
    y2: 54.0825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2164_1087",
    x1: 62.9138,
    y1: 54.6844,
    x2: 65.3999,
    y2: 54.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2164_1087",
    x1: 54.4537,
    y1: 57.5105,
    x2: 55.4486,
    y2: 57.5105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2164_1087",
    x1: 55.4517,
    y1: 55.1292,
    x2: 56.5122,
    y2: 55.1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2164_1087",
    x1: 54.4537,
    y1: 56.3362,
    x2: 56.5091,
    y2: 56.3362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2164_1087",
    x1: 56.5172,
    y1: 56.9199,
    x2: 60.1576,
    y2: 56.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2164_1087",
    x1: 61.585,
    y1: 54.3946,
    x2: 62.9095,
    y2: 54.3946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2164_1087",
    x1: 61.585,
    y1: 52.87,
    x2: 65.3956,
    y2: 52.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2164_1087",
    x1: 65.3979,
    y1: 52.0187,
    x2: 66.8926,
    y2: 52.0187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2164_1087",
    x1: 51.0323,
    y1: 54.0825,
    x2: 50.0374,
    y2: 54.0825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2164_1087",
    x1: 42.5892,
    y1: 54.6844,
    x2: 40.1029,
    y2: 54.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2164_1087",
    x1: 51.0323,
    y1: 57.5105,
    x2: 50.0374,
    y2: 57.5105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2164_1087",
    x1: 50.0443,
    y1: 55.1292,
    x2: 48.9838,
    y2: 55.1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2164_1087",
    x1: 51.0392,
    y1: 56.3362,
    x2: 48.9838,
    y2: 56.3362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2164_1087",
    x1: 48.9917,
    y1: 56.9199,
    x2: 45.3512,
    y2: 56.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2164_1087",
    x1: 43.9117,
    y1: 54.3946,
    x2: 42.5872,
    y2: 54.3946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2164_1087",
    x1: 43.9137,
    y1: 52.87,
    x2: 40.1029,
    y2: 52.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2164_1087",
    x1: 40.0964,
    y1: 52.0187,
    x2: 38.6018,
    y2: 52.0187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c01eaff047deffb5c0b6adb1b86d0629.svg";
export { ForwardRef as ReactComponent };